/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ClientResponse
 */
export interface ClientResponse {
    /**
     * 
     * @type {string}
     * @memberof ClientResponse
     */
    clientId: string;
    /**
     * 
     * @type {string}
     * @memberof ClientResponse
     */
    caseNumber: string;
    /**
     * 
     * @type {string}
     * @memberof ClientResponse
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof ClientResponse
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof ClientResponse
     */
    fullName?: string | null;
}

/**
 * Check if a given object implements the ClientResponse interface.
 */
export function instanceOfClientResponse(value: object): value is ClientResponse {
    if (!('clientId' in value) || value['clientId'] === undefined) return false;
    if (!('caseNumber' in value) || value['caseNumber'] === undefined) return false;
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    return true;
}

export function ClientResponseFromJSON(json: any): ClientResponse {
    return ClientResponseFromJSONTyped(json, false);
}

export function ClientResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClientResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'clientId': json['clientId'],
        'caseNumber': json['caseNumber'],
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'fullName': json['fullName'] == null ? undefined : json['fullName'],
    };
}

export function ClientResponseToJSON(json: any): ClientResponse {
    return ClientResponseToJSONTyped(json, false);
}

export function ClientResponseToJSONTyped(value?: ClientResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'clientId': value['clientId'],
        'caseNumber': value['caseNumber'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'fullName': value['fullName'],
    };
}

